module.exports = __webpack_public_path__ + "img/logo.449c997c.png";